import './confirm-dialog.scss';

import { Box, IconButton } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { NewConvergeButton } from './new-button';
import { ReactNode } from 'react';

interface ConfirmDialogProps {
  title: string;
  content: string | ReactNode;
  show: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  isSubmitting?: boolean;
  onlySubmitButton?: boolean;
}

export const ConfirmDialog = ({
  title,
  content,
  show,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  onCancel,
  isSubmitting,
  onlySubmitButton = true,
}: ConfirmDialogProps) => {
  return (
    <Dialog
      open={show}
      id="confirm-dialog"
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className="binder-title-modal">
        <Box>{title}</Box>

        <IconButton aria-label="close" onClick={onCancel} size="small">
          <CloseIcon
            sx={{
              marginBottom: '0',
              width: '24px',
              height: '24px',
            }}
          />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="alert-dialog-description"

          // sx={{ p: 5 }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {onlySubmitButton === true && (
          <Box className="bind-close-btn">
            <NewConvergeButton
              onClick={() => onCancel && onCancel()}
              label={cancelButtonText || 'Cancel'}
              variant="outlined"
            />
          </Box>
        )}
        <Box className="bind-confirm-btn">
          <NewConvergeButton
            onClick={onConfirm}
            autoFocus
            loading={isSubmitting}
            label={confirmButtonText || 'Confirm'}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};
